var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-nav',{attrs:{"backImage":"","bgColor":"#fff"},on:{"back":_vm.back}},[_c('span',{staticClass:"title"},[_vm._v("费率明细")])]),_c('img',{attrs:{"src":_vm.product.imgSrc,"alt":""}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.product.hint)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }